import BaseModel from '../BaseModel';

export default class SystemNotificationSettings extends BaseModel {
  static entity = 'systemNotificationSettings';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      receiveEmailNotifications: this.boolean(false),
    };
  }

  static apiConfig = {
    actions: {
      fetchSettings() {
        return this.get('system-notifications/settings', { save: false });
      },
      updateSettings(payload) {
        return this.patch('system-notifications/settings', payload, { save: false });
      },
    },
  }
}
